import {ReactNode, useEffect, useLayoutEffect} from 'react';

import SmoothieBottomSheet from '@kakao/smoothie-bottomsheet';
import {addPaddingOnGroupEmptyWithModalBody} from '@zzng/common/markup/addPaddingOnGroupEmpty';

import {useStatusBarDimmedColor} from '@/shared/hooks/useStatusBarDimmedColor';
import {useHalfviewStore} from '@/shared/stores/halfview';

type Props = {
  classnames: string;
  children: ReactNode;
  onExited: () => void;
  onExit?: () => void;
};

const Wrapper = ({classnames, children, onExited, onExit}: Props) => {
  const {open, isFullView, openHalfview, closeHalfview} = useHalfviewStore();

  const handleExited = () => {
    // 닫힐 때 아직 하프뷰 상태가 open이면 closeHalfview 호출
    if (open) {
      closeHalfview();
    }
    onExited();
  };

  useStatusBarDimmedColor(open);

  useEffect(() => {
    openHalfview();
  }, []);

  return (
    <SmoothieBottomSheet
      open={open}
      className={classnames}
      onExited={handleExited}
      onExit={onExit}
      onClickDimmed={closeHalfview}
      showFullView={isFullView}
      /** 딤드 영역은 애니메이션이 동작하지 않도록 설정 */
      dimmedStyle={{opacity: open ? 1 : 0}}
    >
      {children}
    </SmoothieBottomSheet>
  );
};

interface HeaderProps {
  children?: ReactNode;
  className?: string;
  onClickPrev?: () => void;
}

const Header = ({children, className, onClickPrev}: HeaderProps) => (
  <SmoothieBottomSheet.Header className={className}>
    {onClickPrev && <SmoothieBottomSheet.HeaderBackButton onClick={onClickPrev} />}
    {children}
  </SmoothieBottomSheet.Header>
);

interface BodyProps {
  children: ReactNode;
  className?: string;
}

const Body = ({children, className}: BodyProps) => (
  <SmoothieBottomSheet.Body className={className}>{children}</SmoothieBottomSheet.Body>
);

interface FooterProps {
  children: ReactNode;
}

const Footer = ({children}: FooterProps) => <SmoothieBottomSheet.Footer>{children}</SmoothieBottomSheet.Footer>;

const Loading = () => {
  useLayoutEffect(() => {
    addPaddingOnGroupEmptyWithModalBody();
  }, []);

  return (
    <div className="group_empty">
      <span className="icon_loading"></span>
    </div>
  );
};

export default {
  ...SmoothieBottomSheet,
  Wrapper,
  Header,
  Body,
  Footer,
  Loading
};
